import {
  BaSeButton,
  BaSeHeading6,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';

import React from 'react';
import { useManageClassController } from '../../../../../../hooks/controllers/manage-class-controller';
import { useMessage } from '../../../../../../hooks/messages/useMessage';
import { AlignRow } from './form-new-class-style';

function formatarDataParaString(dataOriginal) {
  const dataObj = new Date(dataOriginal);

  const dia = String(dataObj.getUTCDate()).padStart(2, '0');
  const mes = String(dataObj.getUTCMonth() + 1).padStart(2, '0'); // Mês é base 0, então adicionamos 1
  const ano = String(dataObj.getUTCFullYear()).padStart(4, '0');

  return `${dia}/${mes}/${ano}`;
}

function SeeDataNewClassRoom({
  closeModal,
  empretecName,
  uf,
  cidade,
  endDate,
  beginDate,
  option,
  closeFormNewClass,
  dtoCreateClass,
  handleUpdateColumns,
  valueSeminar,
  active,
  regionalSelected,
}) {
  const { postCreateClassRoom } = useManageClassController();
  const { handleSuccess, handleError } = useMessage();
  const [loading, setLoading] = React.useState(false);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
      <BaSeHeading6
        color={BaSeTheme.colors.feedbackInterface.atencao55}
        isBold={true}
      >
        Atenção!
      </BaSeHeading6>

      <BaSeParagraph isBold>
        Tem certeza que deseja criar uma nova turma no{' '}
        <strong>{empretecName}</strong>?
      </BaSeParagraph>

      <div>
        <AlignRow>
          <BaSeParagraph>UF do seminário:</BaSeParagraph>
          <BaSeParagraph
            color={BaSeTheme.colors.institucionais.cinzaSebrae60}
          >{`${uf?.label}`}</BaSeParagraph>
        </AlignRow>
        <AlignRow>
          <BaSeParagraph>Regional:</BaSeParagraph>

          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
            {regionalSelected[0].label}
          </BaSeParagraph>
        </AlignRow>
        <AlignRow>
          <BaSeParagraph>Cidade:</BaSeParagraph>
          <BaSeParagraph
            color={BaSeTheme.colors.institucionais.cinzaSebrae60}
          >{`${cidade?.label}`}</BaSeParagraph>
        </AlignRow>
      </div>

      <div>
        <BaSeParagraph>
          As datas definidas de realização do seminário foram:
        </BaSeParagraph>
        <div>
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
            {`Data de início: ${formatarDataParaString(beginDate)}`}
          </BaSeParagraph>
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
            {`Data de término: ${formatarDataParaString(endDate)}`}
          </BaSeParagraph>
        </div>
      </div>

      <AlignRow>
        <BaSeParagraph>Valor do seminário:</BaSeParagraph>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {`R$ ${valueSeminar}`}
        </BaSeParagraph>
      </AlignRow>

      <AlignRow>
        <BaSeParagraph>Ocultar turma no portal:</BaSeParagraph>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {active ? 'Sim' : 'Não'}
        </BaSeParagraph>
      </AlignRow>

      <div style={{ display: 'flex', gap: 8 }}>
        <BaSeButton
          onClick={() => {
            setLoading(true);

            const dtoCreateClassFormated = {
              ...dtoCreateClass,
              hidePortal: active,
              regionalId: regionalSelected[0].id,
              cityId: cidade.id,
              seminarValue: parseFloat(
                dtoCreateClass.seminarValue
                  .replace(/\./g, '')
                  .replace(',', '.'),
              ),
            };
            postCreateClassRoom(dtoCreateClassFormated)
              .then(() => {
                handleSuccess('Turma criada com sucesso!');
                closeModal(option);
                closeFormNewClass(option);
                handleUpdateColumns();
              })
              .catch(() => {
                handleError('Erro ao tentar criar turma!');
                closeModal(option);
              })
              .finally(() => setLoading(false));
          }}
          type="primary"
          color={BaSeTheme.colors.institucionais.cinzaSebrae10}
          value="Confirmar"
          isLoading={loading}
        />
        <BaSeButton
          onClick={() => closeModal()}
          type="secondary"
          color={BaSeTheme.colors.institucionais.cinzaSebrae10}
          value="Revisar"
          isDisabled={loading}
        />
      </div>
    </div>
  );
}

export default SeeDataNewClassRoom;
